<template>
    <k-page background="bg-white">
        <template v-slot:header>
            <registration-header/>
        </template>
        <k-container class="py-10">
            <div class="max-w-3xl mx-auto">
                <h1 class="text-3xl font-bold mb-8">{{ $t("registration") }}</h1>
                <email-verification-form/>
            </div>
        </k-container>
        <template v-slot:footer>
            <k-footer/>
        </template>
    </k-page>
</template>

<script>
    import RegistrationHeader from '@investor/components/registration/RegistrationHeader';
    import EmailVerificationForm from '@investor/components/registration/EmailVerificationForm';

    export default {
        components: {
            RegistrationHeader,
            EmailVerificationForm
        }
    }
</script>


